jQuery(document).ready(function($) {
    reloadFormSubmitAnimations();
    $( document ).ajaxComplete(function() {
       setTimeout(function() {
           reloadFormSubmitAnimations();
       },50);
    });
    function reloadFormSubmitAnimations() {
        $('form').submit(function(e) {
            $(this).removeClass('submitted').addClass('submitted');
            setTimeout(function() {
                $(this).removeClass('submitted');
            }.bind($(this)),500);
        });
    }
});